module.exports = __webpack_public_path__ + "img/select-type__02.e1176d35.png";